export { authConfig } from './auth.config';
export * from './app.config';
